import { render, staticRenderFns } from "./UnitEditor.vue?vue&type=template&id=21232ad4&scoped=true"
import script from "./UnitEditor.vue?vue&type=script&lang=js"
export * from "./UnitEditor.vue?vue&type=script&lang=js"
import style0 from "./UnitEditor.vue?vue&type=style&index=0&id=21232ad4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21232ad4",
  null
  
)

export default component.exports